import { useEffect, useState } from 'react'

import { MapContainer, TileLayer } from 'react-leaflet'

import { profile } from '../../data/portfolio'
import AnimatedLetters from '../AnimatedLetters'
import ArrowIcon from '../ArrowIcon'
import MessageForm from './MessageForm'
import './index.scss'

export default function Contact() {
  const [letterClass, setLetterClass] = useState('text-animate')
  useEffect(() => { const timer = setTimeout(() => setLetterClass('text-animate-hover'), 2000); return () => clearTimeout(timer) }, [])
  return <div className="container contact-page">
    <div className="text-zone">
      <h1><AnimatedLetters letterClass={letterClass} strArray={'Contact Me'.split('')} idx={15} /></h1>
      <p>Interested in software, agent security, or building something useful? Let's connect.</p>
      <a className="flat-button" href={profile.linkedin} target="_blank" rel="noreferrer">CONNECT ON LINKEDIN <ArrowIcon /></a>
      <div className="contact-form">
        <MessageForm />
      </div>
    </div>
    <div className="map-wrap"><MapContainer center={[40.76, -73.98]} zoom={11} scrollWheelZoom={false}><TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" /></MapContainer><div className="info-map">Omar Abdelrazek<br /><span>Staten Island, NY<br /><span>Computer Science & Information Security</span></span></div></div>
  </div>
}
